import api from '../callApi';

const apiUrl = 'https://api.geocod.io/v1';
const apiKey = '7fe6aa65a87288cfe6388276ce28a855e8fc855';

function mapFreegeoipResponse(json) {
    if (!json || !json.results || !json.results.length) return null;

    const mostRelevantResult = json.results[0];
    if (!mostRelevantResult.fields || mostRelevantResult.accuracy < 0.1) return null;

    return {
        district: mostRelevantResult.fields.congressional_district.district_number,
        state: mostRelevantResult.address_components.state,
        postalCode: mostRelevantResult.address_components.zip,
        address: {
            country: mostRelevantResult.address_components.country,
            state: mostRelevantResult.address_components.state,
            city: mostRelevantResult.address_components.city,
            zipCode: mostRelevantResult.address_components.zip,
            street: mostRelevantResult.address_components.street,
            streetNo: mostRelevantResult.address_components.number
        }
    };
}

function getGeocodeUrl(address, latitude, longitude) {
    return !address
        ? `${apiUrl}/reverse?q=${latitude},${longitude}&api_key=${apiKey}&fields=cd`
        : `${apiUrl}/geocode?q=${address}&api_key=${apiKey}&fields=cd`;
}

function getGeocodeData(latitude, longitude, address) {
    const url = getGeocodeUrl(address, latitude, longitude);

    return api.get(url).then(json => {
        let response = null;
        try {
            response = mapFreegeoipResponse(json);
            if (response.address.country !== 'US') {
                return Promise.reject('NotUsBasedError');
            }
        } catch (e) {
            return Promise.reject(e);
        }

        if (response == null) return Promise.reject(json);

        return { ...response, isUserInput: address != null };
    });
}

export default getGeocodeData;



// WEBPACK FOOTER //
// ./src/utils/localRepresentative/geocodeio-service.js